import { useState } from 'react'

/**
 * An insurer's mark, beside its name wherever prices are compared.
 *
 * The marks are the same SVGs the marketing site ships (`public/insurers/<slug>.svg`, copied from
 * `apps/site/public/insurers`) — versioned in the repo, not uploaded, because they change with the
 * company and not with content. `logoUrl` from the API wins when an operator has set one. A
 * company with no file falls back to its initial on a tile rather than a broken image.
 */
export function InsurerLogo({
  insurer,
  size = 'md',
}: {
  insurer: { slug: string; name: string; logoUrl: string | null }
  size?: 'sm' | 'md'
}) {
  const [failed, setFailed] = useState(false)
  const box = size === 'sm' ? 'h-8 w-8 rounded-lg' : 'h-11 w-11 rounded-xl'
  const initial = insurer.name.replace(/^بیمه\s+/, '').charAt(0)

  if (failed) {
    return (
      <span
        aria-hidden
        className={`${box} grid shrink-0 place-items-center bg-brand-50 text-sm font-bold text-brand-700 dark:bg-brand-900/40 dark:text-brand-200`}
      >
        {initial}
      </span>
    )
  }

  return (
    <span className={`${box} grid shrink-0 place-items-center border border-line bg-white p-1.5`}>
      <img
        src={insurer.logoUrl ?? `/insurers/${insurer.slug}.svg`}
        alt=""
        className="h-full w-full object-contain"
        onError={() => setFailed(true)}
      />
    </span>
  )
}
